import "./css/SVGButton.css";
import { useState } from "react";
import BSModal from "./BSModal";

const SVGButtonModal = ({ svg, tooltip, modal_html }) => {
	const [modal_display_bool, setModalDisplay] = useState(false);
	const handleModalShow = (event) => {
		const elem = getSVGButtonElement(event);
		if (elem !== undefined) {
			setModalDisplay(true);
		}
	};
	const modal_props_js = { modal_display_bool, setModalDisplay, modal_html };

	const getSVGButtonElement = (event) => {
		let elem;
		switch (event.target.tagName) {
			case "svg":
				elem = event.target.parentElement;
				break;
			case "BUTTON":
				elem = event.target;
				break;
			default:
				elem = event.target.closest(".btn_svg_class");
		}
		return elem;
	};
	return (
		<>
			<button
				className="btn_svg_class"
				data-tooltip={tooltip}
				data-whatever={modal_html}
				onClick={handleModalShow}
				data-bs-toggle="tooltip"
				data-bs-placement="top"
				title={tooltip}
			>
				{svg}
			</button>
			<BSModal {...modal_props_js} />
		</>
	);
};

export default SVGButtonModal;
